import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Calculates the average of a list of numbers, ignoring null values.
 * @param list - The list of numbers to calculate the average of.
 * @returns The average of the list of numbers
 */
export function calculateAverage(list: Array<number | null>): number {
  const filteredList = list.filter((item): item is number => item !== null);
  if (filteredList.length === 0) return 0;
  return filteredList.reduce((acc, val) => acc + val, 0) / filteredList.length;
}
